import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class InputField extends Component{
  render(){
    const { field, invalidField, InvalidInputClass, errorMessage, icon } = this.props,
          Tag = field.tag;
    return(
      <label className={field.labelClass +' relative-position '+ (invalidField ? InvalidInputClass : '')}>
      <span className="label-like">{ field.label }</span>
      <Tag 
        className={ field.fieldClass } 
        type={ field.type } 
        disabled={field.disabled}
        name={ field.name } 
        placeholder={ field.placeholder } 
        value={ field.value }
        onChange={ field.onChangeFunc } >
      </Tag>
      { errorMessage }
      { icon }
    </label>
    );
  }
}

InputField.propTypes = {
  field: PropTypes.object,
  invalidField: PropTypes.bool,
  InvalidInputClass: PropTypes.string,
  errorMessage: PropTypes.element,
  icon: PropTypes.element,
  fieldClass: PropTypes.string
}